export const AUTH_SESSION_EXPIRED_EVENT = 'auth:session-expired';

let sessionExpirationDispatched = false;

const AUTH_FAILURE_MESSAGES = [
  'Nieprawidłowy token',
  'Token dostępu wymagany',
  'Brak tokenu autoryzacji',
  'Konto zostało dezaktywowane',
  'Invalid token',
  'Authentication error: Invalid token'
];

const safeLocalStorage = () => {
  if (typeof window === 'undefined') {
    return null;
  }

  try {
    return window.localStorage;
  } catch {
    return null;
  }
};

export const getStoredAuthToken = (): string | null => {
  const storage = safeLocalStorage();
  const rawToken = storage?.getItem('authToken') || null;
  const token = rawToken?.trim();

  if (!token || token === 'null' || token === 'undefined') {
    return null;
  }

  return token;
};

export const clearStoredAuthSession = (): void => {
  const storage = safeLocalStorage();
  if (!storage) {
    return;
  }

  storage.removeItem('authToken');
  storage.removeItem('token');
  storage.removeItem('user');
};

export const markAuthSessionActive = (): void => {
  sessionExpirationDispatched = false;
};

export const isAuthFailureResponse = (status?: number, data?: unknown): boolean => {
  if (status === 401) {
    return true;
  }

  if (status !== 403) {
    return false;
  }

  const message = typeof data === 'object' && data !== null && 'message' in data
    ? String((data as { message?: unknown }).message || '')
    : typeof data === 'string'
      ? data
      : '';

  return AUTH_FAILURE_MESSAGES.some((authMessage) => message.includes(authMessage));
};

export const expireAuthSession = (reason = 'auth-failure'): void => {
  clearStoredAuthSession();

  if (sessionExpirationDispatched || typeof window === 'undefined') {
    return;
  }

  sessionExpirationDispatched = true;
  window.dispatchEvent(new CustomEvent(AUTH_SESSION_EXPIRED_EVENT, { detail: { reason } }));
};
